import background from 'assets/img/background-login.jpg'
import logoNormal from 'assets/img/logo-normal.svg'
import ResetPasswordForm from 'forms/Login/ResetPasswordForm'
import useFetch from 'hooks/useFetch'
import { useToast } from 'hooks/useToast'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

export default function ResetPassword({ params }) {
  const { showToast } = useToast()

  // Get reset token
  const token = params.token

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [requestedResetPassword, requestResetPassword] = useFetch()

  // useState()
  const [error, setError] = useState(null)
  const [showGuide, setShowGuide] = useState(false)

  // CRUD: POST
  const handleSubmit = async (values) => {
    const apiCallParams = {
      url: `auth/reset-password/${token}`,
      method: 'POST',
      body: values,
      messageKo: '¡El enlace no funciona!'
    }
    await requestResetPassword(apiCallParams)
  }

  // Escuchar POST
  useEffect(() => {
    if (requestedResetPassword.data) {
      setShowGuide(true)
      setError(null)
    }
  }, [requestedResetPassword.data])

  // Mostrar mensaje API: POST / PUT (notificación de éxito o error)
  useEffect(() => {
    if (requestedResetPassword.isCalled) {
      if (requestedResetPassword.message) {
        showToast(requestedResetPassword.message, 'success')
        setShowGuide(true)
      }

      if (requestedResetPassword.error) {
        showToast(requestedResetPassword.error, 'error')
        setError('¡El enlace ha expirado!')
      }
    }
  }, [requestedResetPassword.loading])

  return (
    <div className="flex items-center w-screen h-dvh">
      <div
        className="fixed z-10 block w-full h-full bg-top brightness-50"
        style={{
          background: `url(${background})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      />

      <div className="relative z-50 flex items-center justify-center w-full">
        <div className="w-11/12 max-w-lg overflow-hidden bg-white rounded-lg shadow-lg sm:w-full dark:lg:bg-gray-800">
          <div className="flex justify-center w-full p-0">
            <div className="w-full h-24 overflow-hidden border-4 border-white rounded-t-lg bg-base">
              <img
                className="pb-1 mx-auto -mt-4 size-32"
                src={logoNormal}
                alt="Claim Sphere"
              />
            </div>
          </div>

          <ResetPasswordForm
            showGuide={showGuide}
            error={error}
            requestedResetPassword={requestedResetPassword}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

ResetPassword.propTypes = {
  params: PropTypes.any
}
